
export class ErrorTools {

  static unsupported(): Error {
    return new Error('unsupported');
  }
}
